$(document).ready(function () {
    var currencySymbol = $('#currencySymbolForJs').val();

    $('.val_check').each(function () {
        if ($(this).is(":checked")) {
            addToCart($(this));
        } else {
            removeFromCart($(this));
        }
    });

    $("#old_price").html(currencySymbol + number_format(getTotal(), 2));

    $('.val_check').click(function () {
        if ($(this).is(':checked')) {
            $("#old_price").html(currencySymbol + number_format(getTotal(), 2));
            addToCart($(this));
        } else {
            $("#old_price").html(currencySymbol + number_format(getTotal(), 2));
            removeFromCart($(this));
        }
    });
    var format = function (num) {
        var str = num.toString().replace(currencySymbol, ""), parts = false, output = [], i = 1, formatted = null;
        if (str.indexOf(".") > 0) {
            parts = str.split(".");
            str = parts[0];
        }
        str = str.split("").reverse();
        for (var j = 0, len = str.length; j < len; j++) {
            if (str[j] != ",") {
                output.push(str[j]);
                if (i % 3 == 0 && j < (len - 1)) {
                    output.push(",");
                }
                i++;
            }
        }
        formatted = output.reverse().join("");
        return (currencySymbol + formatted + ((parts) ? "." + parts[1].substr(0, 2) : ""));
    };


    // submit form on tab key press
    $('#residential_status_dropdown, .state_of_incorporation_dropdown_chosen, input[name="auth_share_capital"]').on('keydown', function (e) {
        //console.log(e.keyCode);
        if (e.keyCode == 9) {
            $('#orderform').submit();

        }
    });


    $('#residential_status_dropdown > li > ul > li > a').on('click', function () {
        var text = $(this).text();
        var value = $(this).attr('data-value');
        $('#residential_status').val(value);
    });

    $('#company_type_dropdown > li > ul > li > a').on('click', function () {
        var text = $(this).text();
        var value = $(this).attr('data-value');
        $('#company_type').val(value);
    });

    $('#state_of_incorporation_dropdown > li > ul > li > a').on('click', function () {
        var text = $(this).text();
        var value = $(this).attr('data-value');
        $('#state_of_incorporation').val(value);
    });


    /* Set default values in custom dropdown */
    var soi_text = $('#state_of_incorporation_dropdown > li > ul > li > a[data-value="' + $('#state_of_incorporation').val() + '"]').text();
    $('#state_of_incorporation_dropdown a:first').html(soi_text);

    var ct_text = $('#company_type_dropdown > li > ul > li > a[data-value="' + $('#company_type').val() + '"]').text();
    $('#company_type_dropdown a:first').html(ct_text);

    var rs_text = $('#residential_status_dropdown > li > ul > li > a[data-value="' + $('#residential_status').val() + '"]').text();
    $('#residential_status_dropdown a:first').html(rs_text);


    function numberWithCommas(x) {
        x = x.toString();
        var pattern = /(-?\d+)(\d{3})/;
        while (pattern.test(x))
            x = x.replace(pattern, "$1,$2");
        return x;
    }
    
    $('body').on('change', '#additional_director', function () {
        var director_numbers = $(this).val();
        var amount = $('#additional_director_check').attr('data-val');
        $('#adprice').html(numberWithCommas(director_numbers * amount));
        if ($('#additional_director_check').is(":checked")) {
            $('.cartitems #adprice').html(number_format(director_numbers * amount, 2));
            // alert(number_format(director_numbers * amount,2));
            $("#old_price").html(currencySymbol + number_format(getTotal(), 2));
        }
    });
    $("#additional_director, input[name='auth_share_capital']").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .      110, 190
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });





});

function addToCart(element) {
    var link = element.parent().parent().find('a');
    var amount = element.parent().find('label').html();
    var label = element.parent().find('label');
    var str = '<div id="cart_' + label.attr('for') + '" class="row item-list">';
    str += '<div class="col-md-8 col-sm-8">' + link.text() + '</div>';
    str += '<div class="col-md-4 col-sm-4">' + amount + '</div>';
    str += '</div>';
    $('.cartitems').append(str);
}

function removeFromCart(element) {
    var label = element.parent().find('label');
    $('#cart_' + label.attr('for')).remove();
}


function getTotal() {
    var subTotal = parseInt($('#statutory_fee').val()) + parseInt($('#company_incorporation_fees').val());

    $.each($('.val_check'), function () {
        if ($(this).is(":checked")) {
            if ($(this).attr('id') == 'additional_director_check') {
                var total_directors = $('#additional_director').val();
                //$('#ad').val(total_directors);
                if (total_directors >= 1) {
                    subTotal += (total_directors * $(this).attr('data-val'));
                }
            } else {
                subTotal += parseInt($(this).attr('data-val'));
            }
        }
        //console.log(subTotal);
    });

    return subTotal;
}